// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions} from "firebase/functions";
import { getStorage } from "firebase/storage";


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBMcuDYHhjL-KI7R0nW8B_KeUBg_e3HYD0",
  authDomain: "exeonic-test.firebaseapp.com",
  databaseURL: "https://exeonic-test-default-rtdb.firebaseio.com",
  projectId: "exeonic-test",
  storageBucket: "exeonic-test.appspot.com",
  messagingSenderId: "296231647130",
  appId: "1:296231647130:web:07d74255600f48dedeac23",
  measurementId: "G-J2F0D02D8Z"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app)
const functions = getFunctions(app)

export { app, auth,  functions, db };
export const storage = getStorage();
